import { technicianList } from "constants/technician";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const addTechnician = async (bodyData) => {
  try {
    const res = await API.add_technician(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getTechnicianList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.technician_list(pageNum, filters);
    dispatch({ type: technicianList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: technicianList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};

export const getTechnicianById = async (id) => {
  try {
    const res = await API.get_technician_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateTechnicianById = async (id, bodyData) => {
  try {
    const res = await API.edit_technician(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteTechnicianById = async (id) => {
  try {
    const res = await API.delete_technician_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}

export const importTechnician = async (fileData) => {
  try {
    const res = await API.import_technician(fileData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const exportTechnicianData = async (filtersJSON) => {
  try {
    const res = await API.technician_csv_export(filtersJSON); // correct call
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
